import { RouteObject, Navigate } from 'react-router-dom';
import { lazy } from 'react';

// Lazy load components
const Home = lazy(() => import('../pages/home/page'));
const Products = lazy(() => import('../pages/products/page'));
const Testimonials = lazy(() => import('../pages/testimonials/page'));
const Process = lazy(() => import('../pages/process/page'));
const FAQ = lazy(() => import('../pages/faq/page'));
const Admin = lazy(() => import('../pages/admin/page'));
const Blog = lazy(() => import('../pages/blog/page'));
const BlogDetail = lazy(() => import('../pages/blog/[slug]/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const Pricing = lazy(() => import('../pages/pricing/page'));
const Simulator = lazy(() => import('../pages/simulator/page'));
const Privacy = lazy(() => import('../pages/legal/privacy/page'));
const Terms = lazy(() => import('../pages/legal/terms/page'));
const Commerce = lazy(() => import('../pages/legal/commerce/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/products',
    element: <Products />
  },
  {
    path: '/gallery',
    element: <Navigate to="/products" replace />
  },
  {
    path: '/testimonials',
    element: <Testimonials />
  },
  {
    path: '/process',
    element: <Process />
  },
  {
    path: '/faq',
    element: <FAQ />
  },
  {
    path: '/admin',
    element: <Admin />
  },
  {
    path: '/blog',
    element: <Blog />
  },
  {
    path: '/blog/:slug',
    element: <BlogDetail />
  },
  {
    path: '/pricing',
    element: <Pricing />
  },
  {
    path: '/simulator',
    element: <Simulator />
  },
  {
    path: '/privacy',
    element: <Privacy />
  },
  {
    path: '/terms',
    element: <Terms />
  },
  {
    path: '/commerce',
    element: <Commerce />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
